import React from 'react';
import chatBotIcon from './images/sofabuddy_chat_bubble.svg';

export const defaultStyles = {
  chatWindowStyle: {
    left: '1rem'
  },
  chatButtonStyle: {
    left: '1rem'
  },
  tooltipStyle: {
    left: '7rem',
    width: 'fit-content',
    zIndex: '3',
    backgroundColor: '#4b33c4',
    fontWeight: '400',
    fontSize: '.875rem',
    borderRadius: '.75rem'
  },
  headerStyle: {
    height: '4rem',
    background: '#7866d3',
    fontWeight: 'bold',
    fontSize: '1.375rem',
    justifyContent: 'center',
    alignItems: 'center'
  },
  chatHistoryButtonHoveredStyle: {
    background: '#E6E8E5',
    borderRadius: '.25rem',
    color: '#3C3C3C',
    fontSize: '1rem',
    border: '1px solid #000'
  },
  botBubbleStyle: {
    fontFamily: 'Helvetica, Roboto, Arial, sans-serif',
    color: '#333',
    backgroundColor: '#E9E6F8'
  },
  userBubbleStyle: {
    color: '#333',
    backgroundColor: '#FDEB99'
  },
  chatInputAreaStyle: {
    border: '1px solid #E1E1E1',
    borderRadius: '.5rem',
    boxSizing: 'border-box'
  },
  chatInputAreaFocusedStyle: {
    boxShadow: '#7866d3 0 0 0.3125rem'
  },
  sendButtonStyle: {
    backgroundColor: '#7866d3',
    height: '2.5rem'
  },
  sendButtonHoveredStyle: {
    backgroundColor: '#4b33c4',
    height: '2.5rem'
  },
  sendButtonDisabledStyle: {
    backgroundColor: '#a599e1',
    height: '2.5rem'
  },
  chatInputContainerStyle: {
    display: 'none'
  },
  footerStyle: {
    display: 'none'
  },
  chatHistoryButtonStyle: {
    display: 'none'
  }
};

export const visibleInputFieldStyles = {
  chatInputContainerStyle: {
    display: 'flex',
    padding: '1rem 1.5rem',
    borderTop: '1px solid #E1E1E1'
  },
  chatHistoryButtonStyle: {
    display: 'inline-flex',
    background: '#E6E8E5',
    borderRadius: '.25rem',
    color: '#3C3C3C',
    fontSize: '1rem'
  },
  footerStyle: {
    display: 'flex',
    background: '#F8F8F8',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Helvetica, Roboto, Arial, sans-serif',
    fontSize: '0.875rem',
    padding: '0.75rem',
    borderTop: '1px solid #E1E1E1'
  }
};

export const chatbotSettings = (
  t,
  closeChatIcon,
  sofabuddyCookieExists,
  sofabuddyThreadId,
  storageKey
) => {
  const openReveal = () => {
    const reveal = document.getElementById('chatbot-feedback-form-popup');
    $(reveal).foundation('open');
  };

  return {
    header: {
      showAvatar: false,
      title: t('sofabuddy_chat_bot.title'),
      closeChatIcon: closeChatIcon
    },
    chatButton: {
      icon: chatBotIcon
    },
    chatWindow: {
      showMessagePrompt: false
    },
    tooltip: {
      mode: sofabuddyCookieExists === true ? 'NEVER' : 'CLOSE',
      text: (
        <span
          dangerouslySetInnerHTML={{ __html: t('sofabuddy_chat_bot.tooltip') }}
        />
      )
    },
    notification: {
      disabled: true
    },
    general: {
      embedded: false,
      flowStartTrigger: 'ON_CHATBOT_INTERACT',
      fontFamily: 'Open Sans, Helvetica, Arial, sans-serif'
    },
    chatHistory: {
      disabled: !sofabuddyCookieExists,
      storageKey: storageKey,
      viewChatHistoryButtonText: (
        <>
          {t('sofabuddy_chat_bot.show_chat_history')}{' '}
          <i className="icon icon--replay"></i>
        </>
      ),
      chatHistoryLineBreakText: (
        <>{t('sofabuddy_chat_bot.previous_chat_history')}</>
      ),
      autoLoad: !!sofabuddyThreadId
    },
    botBubble: {
      dangerouslySetInnerHtml: true,
      simStream: window.Sofatutor.env === 'test' ? false : true
    },
    chatInput: {
      enabledPlaceholderText: t('sofabuddy_chat_bot.placeholder_text')
    },
    footer: {
      text: t('sofabuddy_chat_bot.mistake_hint'),
      buttons: [
        <button
          key="feedback-button"
          className="sofabuddy-feedback-form-link"
          onClick={openReveal}
        >
          {t('sofabuddy_chat_bot.feedback_link_text')}
        </button>
      ]
    },
    fileAttachment: {
      disabled: true
    },
    emoji: {
      disabled: true
    },
    event: {
      rcbLoadChatHistory: true,
      rcbUserSubmitText: true,
      rcbToggleChatWindow: true
    }
  };
};
